"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentRelated = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
let ComponentRelated = class ComponentRelated extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = 'Related';
        this.items = [];
    }
    render() {
        return (0, lit_1.html) `
      <section class="component-related">
        <mm-heading level="2">${this.heading}</mm-heading>
        <mm-button-group>
          ${this.items.map(item => (0, lit_1.html) `
                <mm-hashtag-link href=${item.href}>${item.label}</mm-hashtag-link>
              `)}
        </mm-button-group>
      </section>
    `;
    }
};
ComponentRelated.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    .component-related {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
      padding: var(--space-section) 0;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ComponentRelated.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], ComponentRelated.prototype, "items", void 0);
ComponentRelated = __decorate([
    (0, decorators_js_1.customElement)('mm-component-related')
], ComponentRelated);
exports.ComponentRelated = ComponentRelated;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LXJlbGF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21wb25lbnQtcmVsYXRlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELCtCQUE0QjtBQVFyQixJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBQXpDOztRQWF1QixZQUFPLEdBQUcsU0FBUyxDQUFBO1FBQ2YsVUFBSyxHQUErQixFQUFFLENBQUE7SUFpQnhFLENBQUM7SUFmQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7Z0NBRWlCLElBQUksQ0FBQyxPQUFPOztZQUVoQyxJQUFJLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FDZCxJQUFJLENBQUMsRUFBRSxDQUNMLElBQUEsVUFBSSxFQUFBO3dDQUNzQixJQUFJLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxLQUFLO2VBQ2hELENBQ0o7OztLQUdOLENBQUE7SUFDSCxDQUFDOztBQTdCTSx1QkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7OztHQVdsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztpREFBb0I7QUFDZjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7K0NBQXVDO0FBZDNELGdCQUFnQjtJQUQ1QixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZ0JBQWdCLENBK0I1QjtBQS9CWSw0Q0FBZ0IifQ==